/**
 * Accordion.
 *
 * @format
 */

export const loadAccordion = (): void => {
  /**
   * Remove class 'open' from all folds.
   *
   * @param {Array} accordion
   */
  const closeAllFolds = (accordion: HTMLElement) => {
    const folds: NodeListOf<HTMLElement> = accordion.querySelectorAll('.fold');
    if (folds.length > 0) {
      folds.forEach((item) => {
        item.classList.remove('open');
      });
    }
  };

  /**
   * Build Simple Accordion.
   */
  const buildSimpleAccordion = (accordion: HTMLElement) => {
    const items: NodeListOf<HTMLElement> = accordion.querySelectorAll('.fold');

    if (items.length > 0) {
      items.forEach((fold) => {
        const customTag: HTMLElement | null =
          fold.querySelector('.accordion-toggle');
        const accordionHeader: HTMLHeadingElement | null =
          fold.getElementsByTagName('h3').length !== 0
            ? fold.getElementsByTagName('h3')[0]
            : null;
        const clickable: HTMLElement | null = customTag || accordionHeader;
        if (clickable !== null) {
          clickable.addEventListener('click', (event) => {
            const parentClickable = <HTMLElement>(
              (<HTMLElement>event.target).parentNode?.parentNode
            );

            if (parentClickable) {
              if (parentClickable.classList.contains('auto-close')) {
                if (parentClickable.classList.contains('open')) {
                  closeAllFolds(accordion);
                } else {
                  closeAllFolds(accordion);
                  fold.classList.add('open');
                }
              } else {
                fold.classList.toggle('open');
              }
            }
          });
        }
      });
    }
  };

  /**
   * Setup Accordions.
   */
  const setupAccordions = (): void => {
    const accordions: NodeListOf<HTMLElement> =
      document.querySelectorAll('.accordion');
    if (accordions.length > 0) {
      accordions.forEach((accordion: HTMLElement) => {
        buildSimpleAccordion(accordion);
      });
    }
  };
  setupAccordions();
};
